var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTabAlertsIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M6 8.5a4 4 0 0 1 8 0c0 3.8 1.4 4.8 1.4 4.8H4.6S6 12.3 6 8.5ZM8.4 15.8a1.7 1.7 0 0 0 3.2 0"
})));
export default SvgTabAlertsIcon;